module.exports = __webpack_public_path__ + "static/media/personal_accident_white.9e4e1a30.svg";